export enum PaymentMethods{
    BankTransfer = 1, 
    Cash = 2, 
    Cheque = 3, 
    Paypal = 4, 
    Card = 5, 
    Stripe = 6,
    Pmf =7
}